export default __webpack_public_path__ + "static/media/laptop.ce02c0a8.svg";